export default __webpack_public_path__ + "static/media/forward_normal_grey.c7a93e13.svg";